// deps
import { Select } from "@chakra-ui/react";
import { useDateFormatter } from "@react-aria/i18n";

/**
 * @typedef Props
 * @property {object} state
 * @property {import("react").Dispatch<import("react").SetStateAction<any>>} onChangeMonth
 * @property {(event: any) => void} [onChangeFocusDate]
 * @property {boolean} [shouldChangeSelectedDateOnChangeMonthOrYear]
 */
/**
 * @param {Props & import("@chakra-ui/react").SelectProps} props
 * @returns {import("react").FunctionComponentElement<Props>}
 */
function MonthSelector(props) {
  const {
    state,
    onChangeMonth,
    onChangeFocusDate,
    shouldChangeSelectedDateOnChangeMonthOrYear,
    ...otherProps
  } = props;

  let months = [];
  let formatter = useDateFormatter({
    month: "long",
    timeZone: state.timeZone,
  });

  // Format the name of each month in the year according to the
  // current locale and calendar system. Note that in some calendar
  // systems, such as the Hebrew, the number of months may differ
  // between years.
  let numMonths = state.focusedDate.calendar.getMonthsInYear(state.focusedDate);
  for (let i = 0; i < numMonths; i++) {
    let date = state.focusedDate.set({ month: i + 1 });

    if (state.minValue && date.compare(state.minValue) < 0) {
      continue;
    }

    if (state.maxValue && date.compare(state.maxValue) > 0) {
      continue;
    }
    months.push({
      value: i + 1,
      formatted: formatter.format(date.toDate(state.timeZone)),
    });
  }

  let onChange = (e) => {
    let value = Number(e.target.value);
    let date = state.focusedDate.set({ month: value });

    shouldChangeSelectedDateOnChangeMonthOrYear && onChangeMonth(date);
    onChangeFocusDate?.(date);
    state.setFocusedDate(date);
  };

  return (
    <Select
      {...otherProps}
      size="sm"
      w={130}
      aria-label="Month"
      onChange={onChange}
      value={state.focusedDate.month}>
      {months.map((month) => (
        <option key={month.value} value={month.value}>
          {month.formatted}
        </option>
      ))}
    </Select>
  );
}

export default MonthSelector;
